import { Strings } from '@/constants/strings';

interface ToolInfoModalProps {
  visible: boolean;
  title: string;
  body: string;
  onClose: () => void;
}

export function ToolInfoModal({ visible, title, body, onClose }: ToolInfoModalProps) {
  if (!visible) return null;

  return (
    <div
      className="animate-modal-backdrop fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 backdrop-blur-lg"
      role="dialog"
      aria-modal="true"
      aria-labelledby="tool-info-modal-title"
      onClick={onClose}
    >
      <div
        className="animate-modal-content relative flex max-h-[90vh] w-full max-w-md flex-col rounded-3xl bg-white/90 shadow-xl backdrop-blur-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b border-border px-4 py-3">
          <h2 id="tool-info-modal-title" className="text-lg font-bold text-[#1A1A1A]">
            {title}
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="rounded p-1.5 text-[#5C5C5C] hover:bg-surface focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
            aria-label={Strings.close}
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="overflow-y-auto px-4 py-4">
          <p className="text-base leading-relaxed text-[#1A1A1A]">{body}</p>
        </div>

        <div className="border-t border-border px-4 py-3">
          <button
            type="button"
            onClick={onClose}
            className="w-full rounded-xl bg-primary py-3 text-base font-bold text-[#FFFFFF] transition hover:bg-primary-active active:bg-primary-active"
          >
            {Strings.close}
          </button>
        </div>
      </div>
    </div>
  );
}
